module.exports = __webpack_public_path__ + "static/media/benefits-gold.bf171b38.png";